<template>
    <div class="frmdokumentumfeltoltes_formcont">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"></GrcDialog>
        <GrcDocDisplayer ref="DocDisplayer"></GrcDocDisplayer>

        <div class="frmdokumentumfeltoltes_section">

            <GrcCombo ref="cboTipus" v-model="TipusID" grc_labeltext="Dokumentum típusa:"
            grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="300"  
            grc_keyfield="id" grc_displayfield="Megnevezes"
            v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'false'}]"
            v-on:dropdownopened="SetPopupRef('cboTipus')"
            v-on:dropdownclosed="SetPopupRef('')"
            v-on:innerindexbroadcast="tipus_InnerIndexBroadcasted"
            style=""
            />
        </div>
        <div class="frmdokumentumfeltoltes_tajekoztato" v-html="TipusMegjegyzes" v-show="TipusMegjegyzes!=''" />

        <GrcDocMultiSelect ref="MultiDoc" grc_shownoti="true" :grc_maxfiles="MaxFiles" :grc_allowed_extensions="AllowedExtensions"
        v-show="IsMultiDocVisible"></GrcDocMultiSelect>


        <div style="width:100%; box-sizing:border-box; text-align:center; margin:30px 0px;" v-show="IsMultiDocVisible">
            <span @click="Mentes" class="cms_linkbutton cms_linkbutton_2" style="font-size: 16px; line-height: 16px; font-weight: 500; text-decoration: none;">
                <i class="fal fa-upload" style="margin-right:8px;"></i>Feltöltés</span>            
        </div>



    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcDocDisplayer from '../GrcComponents/GrcDocDisplayer.vue'
import GrcDocMultiSelect from '../GrcComponents/GrcDocMultiSelect.vue'

export default {
  name: 'frmdokumentumfeltoltes',
  components: {
      GrcDB,
      GrcDialog,
      GrcCombo,
      GrcCheckboxMobile,
      GrcDocDisplayer,
      GrcDocMultiSelect,
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmDokumentumFeltoltes_",

          InitDone:false,  

          MaxFiles:"5",
          AllowedExtensions:"pdf, jpg",

          TIPUSOK:[],
          TipusID:0,
          TipusMegjegyzes:"",
          IsMultiDocVisible:false,



      }
  },
  model: {

  },  
  methods:{

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmDokumentumFeltoltes", pCompName);
    },

    SetLang()
    {
        this.Init();
    },


    SetControlToFocus(pNextComp)
    {
      if (pNextComp == "") { return; }
      this.$refs[pNextComp].SetFocus();
    },

    tipus_InnerIndexBroadcasted(pIndex)
    {
        this.TipusMegjegyzes = this.TIPUSOK[pIndex].Leiras;

        if (this.TIPUSOK[pIndex].id > 0)
        {
            this.IsMultiDocVisible = true;
        }
        else
        {
            this.IsMultiDocVisible = false;
        }

    },

      async Mentes()
      {
        this.$refs.GRCDB.ShowLoading(false);

        var pFajlok = ""; 
        var FajlCheck = true;

        var UploadOK = true;

        var pUploadID = 0;
        var pMegjegyzes = "";


        var UploadRes = await this.$refs.MultiDoc.UploadFiles(4);

        //console.log(UploadRes);

        if (UploadRes.FileCount == 0) { FajlCheck = false; }
        if (UploadRes.UploadID == "") { UploadOK = false; }
        if (UploadRes.Success == false) { UploadOK = false; }
        
        pUploadID = UploadRes.UploadID;
        pMegjegyzes = UploadRes.Megjegyzes;


        if (UploadOK == false)
        {
          this.$refs.GRCDB.HideLoading();
          await this.ShowInfo("A feltöltés előkészítése sikertelen!", 200);
          return;
        }

        if (FajlCheck == false)
        {
          this.$refs.GRCDB.HideLoading();
          await this.ShowInfo("Legalább egy fájl megadása kötelező!", 200);
          return;
        }


        pFajlok = "<NewDataSet>" + pFajlok + "</NewDataSet>";

      

        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSessionID: "[APPSESSIONID]",
            iTipusID: this.$refs.cboTipus.GetValue(),
            sUploadID:pUploadID,
            sMegjegyzes:pMegjegyzes
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Mentes", QP).then(res => { Q = res; });

        
        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowInfo(Q.APPERR[0].ERR, 200);
            return;
        }

        this.$refs.GRCDB.HideLoading();

       let Azonosito = Q.RESULT[0].Azonosito;


        var strRes = 'Az adatok mentése sikeresen megtörtént!<br><br><b>Azonosító: '+Azonosito+"</b>";

        await this.ShowInfo(strRes, 260);

        document.location = "feltoltott-dokumentumok";

      },


      async Init()
      {
        this.InitDone = false;

        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.TIPUSOK = Q.TIPUSOK;
        this.$refs.cboTipus.SetDataSource(this.TIPUSOK);
        this.$refs.cboTipus.SetValue(0);

        this.InitDone = true;

      },


    async ShowInfo(pText, pHeight)
    {
        var DialogResult = "";
        //await this.$refs.Dialog.Alert("Információ",pText).then(res => { DialogResult = res; });  
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => { DialogResult = res; });               
    },

    async ShowError(pText)
    {
        var DialogResult = "";
        await this.$refs.Dialog.Alert("Hiba", pText).then(res => { DialogResult = res; });
        
    },



  },
  created()
  {

  },
  mounted()
  {
    //console.log("mount");
    this.SetLang();
    
  }

}


</script>


